import React, { Component } from 'react';
import './StatusCarousels.scss';
import { statuses, base } from '../../../../config'
import { objCleaner } from '../../../helpers'
import * as _ from 'lodash'
import Job from '../../../components/Job'
import Carousel from '../../../components/Carousel'

class StatusCarousels extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    };

    _delete (sheetId) {
      console.log(sheetId);
      const _this = this
      base.remove(`user_details/${this.props.uid}/sheets/${sheetId}`, (err) => {
        console.log(err);
      })
      base.remove(`user_details/${this.props.uid}/jobs/${sheetId}`, (err) => {
        console.log(err);
      })
    }

    render() {

        const groups = _.groupBy(this.props.jobs, job => {
          return job.selected_status.value
        })

        const responsive = [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]

        const carousels = this.props.statuses.map((item, index) => {
          return (
            <div key={index} className="panel">
              <div className="panel-heading">
                {item.action_label}
              </div>
              {groups[item.value] &&
                <div className="panel-body">
                  <Carousel settings={{dots: false, centerPadding: '20px', infinite: false, arrows: true, speed: 500, slidesToShow: 4, slidesToScroll: 1, responsive: responsive}}>
                      {groups[item.value].map((item, index) => {
                        return (
                          <div key={`car${index}`} >
                            <div className="col-sm-12" style={{height: 180}}>
                              <Job go history={this.props.history} class='col-sm-' delete={this._delete} key={`${item.key}`} id={`${item.key}`} uid={this.props.uid} job={item} />
                            </div>
                          </div>
                        )
                      })}
                  </Carousel>
                </div>
              }

              {!groups[item.value] &&
                <div className="panel-body">
                  <p className="m-0">You have no jobs in <strong>{item.action_label}</strong></p>
                </div>
              }
            </div>
          )
        })

        return (
            <div className='status-carousels'>
              {carousels}
            </div>
        )
    }
}

export default StatusCarousels;



// WEBPACK FOOTER //
// ./src/views/pages/Jobs/StatusCarousels/index.js